import Blog from './components/Blog'
import './App.css';
import DescriptionList from './components/DescriptionList';

function App() {
  return (
    <>
    <Blog></Blog>
    <DescriptionList></DescriptionList>
    </>
  );
}

export default App;
